// @flow
import numeral from 'numeral';
import GenericSlider from '@components/sliders/GenericSlider';

import { createGetOpts, config } from '@src/utils/sliders';

import type { OnSliderUpdateType } from '@components/containers/Diamonds';

const currencyFormat = '$ 0,0';

const optionsFunc = (values, extents, step, margin) => {
  // hide slider via ErrorBoundary
  if (extents[0] === extents[1]) throw new Error("min and max can't be equal");

  const range  = {
    min: [extents[0], 50],
    max: [extents[1]]
  };

  if (extents[1] > 5000) {
    range['50%'] = [5000, 100];
  }

  if (extents[1] > 20000) {
    range['70%'] = [20000, 1000];
  }

  if (extents[1] > 105000) {
    range['90%'] = [105000, 5000];
  }

  return {
    start: values,
    range: range,
    step: step,
    connect: [false, true, false]
  };
};

type PropsType = {
  onSliderUpdate: OnSliderUpdateType,
  value: Array<number | string> | void,
  extent: Array<number | string>,
  disableTabIndex?: boolean
};

export default class PriceRange extends React.Component<PropsType> {
  render() {
    const { value, extent, onSliderUpdate } = this.props;
    const getOpts = createGetOpts(extent, optionsFunc, config.price);

    return (
      <GenericSlider
        getOpts={getOpts}
        value={value || extent}
        userValue={value}
        extent={extent}
        onSliderUpdate={values => {
          const numberExtents = extent.map(Number);

          // if the user sets the  values to widest, unset the filter
          if (values[0] === numberExtents[0] && values[1] === numberExtents[1]) {
            onSliderUpdate(undefined);
          } else {
            onSliderUpdate(values);
          }
        }}
        formatter={num => numeral(parseFloat(num)).format(currencyFormat)}
        inputWidth={'85px'}
        leftInputAlign='left'
        rightInputAlign='right'
        inputStep={config.price.stepSize}
        inputStepMargin={config.price.margin}
        disableTabIndex={this.props.disableTabIndex}
        inputs
      />
    );
  }
}
